/**
 * gamesis Story API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Campaign { 
    id: string;
    name: string;
    readonly image?: string;
    readonly description?: string;
}

